import { Injectable } from '@angular/core';
import { Permissions, PermissionsService } from '@r1-development/rps-shared-ui';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RbacService {
  approveCARCTable$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  approveRemitRefinementQueries$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  editCARCTable$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  editRemitRefinementQueries$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  viewCARCTable$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  viewRemitRefinementQueries$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  enableEditRules: Observable<boolean> = new BehaviorSubject<boolean>(false);

  enableApproveRules: Observable<boolean> = new BehaviorSubject<boolean>(false);

  enableViewRules: Observable<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private readonly permissionsService: PermissionsService) {
    this.permissionsService.permissions$.subscribe((permissions: string[]) => this.updatePermissions(permissions));
  }

  private updatePermissions(permissions: string[]): void {
    for (const string of permissions) {
      switch (string) {
        case Permissions.Rules.Read:
          (this.enableViewRules as BehaviorSubject<boolean>).next(true);
          break;
        case Permissions.Rules.Write:
          (this.enableEditRules as BehaviorSubject<boolean>).next(true);
          break;
        case Permissions.Rules.Approve:
          (this.enableApproveRules as BehaviorSubject<boolean>).next(true);
          break;
        case Permissions.Rules.Denials.CarcTable.Read:
          (this.viewCARCTable$ as BehaviorSubject<boolean>).next(true);
          break;
        case Permissions.Rules.Denials.CarcTable.Write:
          (this.editCARCTable$ as BehaviorSubject<boolean>).next(true);
          break;
        case Permissions.Rules.Denials.RemitRefinementQuery.Read:
          (this.viewRemitRefinementQueries$ as BehaviorSubject<boolean>).next(true);
          break;
        case Permissions.Rules.Denials.RemitRefinementQuery.Write:
          (this.editRemitRefinementQueries$ as BehaviorSubject<boolean>).next(true);
          break;
        case Permissions.Rules.Denials.RemitRefinementQuery.Approve:
          (this.approveRemitRefinementQueries$ as BehaviorSubject<boolean>).next(true);
          break;
      }
    }
  }
}
